import React from 'react';
import { motion } from 'framer-motion';
export function BodySignals() {
  return <section className="py-12 px-4 bg-cream" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-67">
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium max-w-3xl mx-auto" data-id="element-68">
            Muchos cuidadores creen que el agotamiento que sienten es normal.
            Pero el cuerpo empieza a enviar señales muy claras.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative" data-id="element-69">
          <div className="absolute inset-0 bg-terracotta/10 transform -rotate-1 rounded-2xl" data-id="element-70" />
          <img src="https://cdn.magicpatterns.com/uploads/aQrXb4RY6ZTruVnrPT7jgU/image.png" alt="Señales que tu cuerpo envía — Físicas, Mentales y Emocionales" className="relative rounded-2xl shadow-xl w-full" data-id="element-71" />
        </motion.div>

        <p className="text-center text-lg md:text-xl text-navy/70 italic font-medium mt-6" data-id="element-72">
          En el libro encontrarás mapas como este para entender lo que está
          pasando en tu cuerpo.
        </p>
      </div>
    </section>;
}